import React from "react";
import ReactDOM from "react-dom";
import queryString from "query-string";

import ExtensionWrapper from "../components/ExtensionWrapper/ExtensionWrapper.js";

import TwitchHelper from "../components/TwitchHelper/TwitchHelper";

//Sentry.init({
//  dsn: process.env.SENTRY_DSN,
//  integrations: [new Integrations.BrowserTracing()],
//
//  // We recommend adjusting this value in production, or using tracesSampler
//  // for finer control
//  tracesSampleRate: 1.0,
//});

const queryParams = queryString.parse(window.location.search);

export default function renderExtensionView(children) {
  const isHostedOnTwitch = Boolean(queryParams.state);

  if (!isHostedOnTwitch) {
    document.body.classList.add("fake-background");
  }

  ReactDOM.render(
    <TwitchHelper useFakeTwitchHelperAPI={!isHostedOnTwitch}>
      <ExtensionWrapper>{children}</ExtensionWrapper>
    </TwitchHelper>,
    document.getElementById("root")
  );
}
